import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { POST_LOGIN_REDIRECT_PATH } from "@/features/auth/constants/auth.constants";
import { guardLegalConsents } from "@/features/legal/utils/legal-consent-gate";

/**
 * The athlete's first run after creating their account (ADR 0050). Signed out goes to login; already
 * onboarded goes straight on to where they were heading, unless Stripe is sending them back here.
 */
export const Route = createFileRoute("/onboarding")({
  staticData: { sitemap: false },
  component: OnboardingLayout,
  ssr: false,
  validateSearch: z.object({
    redirect: z.string().optional(),
    checkout: z.enum(["success", "cancelled"]).optional().catch(undefined),
  }),
  beforeLoad: async ({ search, location }) => {
    const { data } = await sdk.users.me.$get.send();
    if (!data) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }

    // The answers are health data, so the consent has to be there first.
    await guardLegalConsents({ userId: data.user.id, location });

    const profile = await sdk.athlete.profile.$get.send();
    if (profile.data?.onboardedAt && !search.checkout) {
      throw redirect({ href: search.redirect ?? POST_LOGIN_REDIRECT_PATH });
    }

    return { user: data };
  },
});

function OnboardingLayout() {
  return (
    <div className="min-h-svh bg-background">
      <Outlet />
    </div>
  );
}
